/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_No_Archived_DescriptionInputs */



/**
* | output |
* | --- |
* | "Spaces you archive are hidden from your list without affecting your colleagues." |
*
* @param {Spaces_No_Archived_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_no_archived_description = /** @type {((inputs?: Spaces_No_Archived_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_No_Archived_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Von Ihnen archivierte Spaces sind nur in Ihrer Liste ausgeblendet — für Ihre Kolleginnen und Kollegen ändert sich nichts.")
	return /** @type {LocalizedString} */ ("Spaces you archive are hidden from your list without affecting your colleagues.")
});